define('modules/htmlad/player/htmlad_player_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/button/button_view',

  'text!./htmlad_player_template.html'
], function (Backbone, $, _, session,
             ButtonView,
             player_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      // Make sure possible external close-functions will be used instead of the built in.
      this.delegateEvents();

      this.render();
      this.orientations = [];
      if (this.model.has('metadata')) {
        this.orientations = this.model.get('metadata').orientations;
      }
      this.orientation = 0;
      this.previousOrientation = -1;
      this.fitHeight = this.fitHeight || 400;
      this.previewHtmlAd();
    },

    className: 'htmlad-player',
    subViews: [],
    template: _.template(player_template),

    events: {
      'click .close': 'close',
      'click .js-toggle-size': 'toggleSize',
      'click .js-add-button a': 'setOrientation',
      'click .js-replay': 'replay'
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    iframeContent: undefined,

    previewHtmlAd: function () {
      var self = this;
      this.iframe = document.createElement('iframe');
      this.iframe.scrolling = 'no';
      this.iframe.classList.add('is-loading');
      this.iframe.addEventListener('load', function (e) {
        $(this).removeClass('is-loading');
        self.setSize(self.iframeSize);
      });
      this.iframe.src = session.get('apiBaseUrl') + this.model.get('preview');

      this.$('.js-htmlad-player-container').html(this.iframe);

      var orientationGroup = [];
      _.forEach(this.orientations, function (orientation, i) {
        var button = new ButtonView({
          label_text: orientation.orientation,
          className: 'button button-text',
          data: {index: i},
          href: '#'
        });
        orientationGroup.push($('<li></li>').html(button.$el));
      });
      this.$('.js-add-button').html(orientationGroup);
    },

    iframeSize: 'fit',

    setSize: function (size) {
      this.$('.js-toggle-size')[size === 'fit' ? 'addClass' : 'removeClass']('is-zoomed');
      this.iframeSize = size;
      var iframeContent = this.iframe.contentWindow;

      var self = this;
      var orientation = {
        width: this.orientations[this.orientation].width,
        height: this.orientations[this.orientation].height,
        ratio: this.fitHeight / this.orientations[this.orientation].height,
        scaleRatio: (function () {
          var container = self.$('.js-htmlad-player-container');
          var iframeRatio = container.width() / self.fitHeight;
          var videoRatio = self.orientations[self.orientation].width / self.orientations[self.orientation].height;

          if (iframeRatio < videoRatio) {
            return container.width() / self.orientations[self.orientation].width;
          } else {
            return self.fitHeight / self.orientations[self.orientation].height;
          }
        }())
      };


      iframeContent.postMessage({
        orientation: this.orientations[this.orientation].orientation,
        scale: size === 'full'? 1 : orientation.scaleRatio
      }, '*');

      switch (size) {
        case 'full':
          $(this.iframe).css({
            width: orientation.width,
            height: orientation.height,
            overflow: 'auto'
          });


          break;
        default:
          // or fit
          $(this.iframe).css({
            width: orientation.width * orientation.scaleRatio,
            height: orientation.height * orientation.scaleRatio,
            overflow: 'hidden'
          });
          break;
      }
    },

    setOrientation: function (e) {
      e.preventDefault();
      //refresh iframe so that video and animation start from begin.
      this.iframe.src = this.iframe.src;
      this.previousOrientation = this.orientation;
      this.orientation = $(e.target).data().index;
      this.setSize(this.iframeSize);
    },

    replay: function (e) {
      e.preventDefault();
      //refresh iframe so that video and animation start from begin.
      this.iframe.src = this.iframe.src;
      this.setSize(this.iframeSize);
    },

    toggleSize: function (e) {
      e.preventDefault();
      var size = this.iframeSize === 'fit' ? 'full' : 'fit';
      this.setSize(size);
    },

    close: function (e) {
      if(e) {
        e.preventDefault();
      }
      this.remove();
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  });
  return View;
});

